require('./bootstrap');
require('jquery');
//import 'jquery-ui/ui/widgets/selectmenu.js';
//Owl Carousel 2
//import 'owl.carousel';
//require('select2')
//require('select2/dist/js/i18n/es')
